import { NgClass, NgStyle } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { CasinoCoreLazyPlaceholderComponent } from '../casino-core-lazy-placeholder/casino-core-lazy-placeholder.component';
import { CategoryiconSubtitleComponent } from '../categoryicon-subtitle/categoryicon-subtitle.component';
import { SignPostingComponent } from '../sign-posting/sign-posting.component';

@Component({
    selector: 'cc-lmt-sub-category-heading',
    templateUrl: 'lmt-sub-category-heading.component.html',
    imports: [NgClass, CasinoCoreLazyPlaceholderComponent, NgStyle, CategoryiconSubtitleComponent, SignPostingComponent],
})
export class LmtSubCategoryHeadingComponent {
    trackingClass = input.required<string>();
    subCategoryInfo = input.required<{
        categoryname: string;
        sitecoreData: {
            attributes: {
                backgroundColor: string;
            };
            backgroundImageLayer1: string;
            backgroundImageLayer2: string;
            backgroundImageLayer3: string;
            showJackpotMoreInfo: boolean;
            jackpotInfo: string;
            jackpotMoreInfoCloseCtaText: string;
        };
    }>();
    parallaxInput = input.required<{
        sitecoreData: any;
    }>();
    isUkHeading = input.required<any>();
    enableEpcotSubNavigation = input.required<string>();
    subCategoryTextColor = input.required<string>();
    lobbyTileFontFamily = input.required<number>();
    ShowArcadeCoinExpiry = input.required<number>();
    subCategoryTitleFontSize = input.required<number>();
    currentLobbyType = input.required<number>();
    arcadeLobbyGameConfig = input.required<number>();
    jackpotMoreInfoEnable = input.required<number>();
    isSignPosting = input.required<number>();
    alignIconRight = input.required<boolean>();

    openDialog = output<Event>();

    onOpenDialog(event: Event) {
        this.openDialog.emit(event);
    }

    hasNoBackgroundImages(): boolean {
        const parallax = this.parallaxInput()?.sitecoreData;
        const subCategory = this.subCategoryInfo()?.sitecoreData;

        const noParallaxBg = !parallax?.backgroundImageLayer1 && !parallax?.backgroundImageLayer2 && !parallax?.backgroundImageLayer3;

        const noSubCategoryBg = !subCategory?.backgroundImageLayer1 && !subCategory?.backgroundImageLayer2 && !subCategory?.backgroundImageLayer3;

        return noParallaxBg && noSubCategoryBg;
    }

    showJackpotMoreInfo() {
        return (
            this.subCategoryInfo()?.sitecoreData?.showJackpotMoreInfo &&
            this.subCategoryInfo()?.sitecoreData?.jackpotInfo &&
            this.jackpotMoreInfoEnable() &&
            this.subCategoryInfo()?.sitecoreData?.jackpotMoreInfoCloseCtaText
        );
    }
}
